// extracted by mini-css-extract-plugin
export default {"layoutOuterContent":"style_layoutOuterContent__vMO6x","layoutInnerContent":"style_layoutInnerContent__ksTfM"};